import EmploymentRecord from './EmploymentRecord';
import {EmployeeBenefitEnrollment, EmployeeInsuranceNumber} from 'main/stores/benefits';
import { observable, makeObservable } from 'mobx';
import {types} from 'main/tools';

class ReactivationRecord extends EmploymentRecord {
  employeeBenefitEnrollments = [];
  employeeInsuranceNumbers = [];
  payrollEnabled;
  nmbrPayScheduleId;

  _relations = {
    ...this._relations,
    employeeBenefitEnrollments: [EmployeeBenefitEnrollment],
    employeeInsuranceNumbers: [EmployeeInsuranceNumber]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      employeeBenefitEnrollments: observable,
      employeeInsuranceNumbers: observable,
      payrollEnabled: observable,
      nmbrPayScheduleId: observable
    });

    this.merge(other);
  }

  _afterMerge() {
    this._type = types.REACTIVATION_RECORD;
  }
}

export default ReactivationRecord;
